<template>
  <div class="pageWrapper">
    <!-- image clipper -->
    <svg class="svg">
      <clipPath id="imageClipper" clipPathUnits="objectBoundingBox">
        <path
          d="M0.975,0 H0.441 C0.427,0,0.416,0.018,0.416,0.04 V0.056 C0.416,0.078,0.405,0.096,0.392,0.096 H0.025 C0.011,0.096,0,0.114,0,0.136 V0.96 C0,0.982,0.011,1,0.025,1 H0.975 C0.989,1,1,0.982,1,0.96 V0.04 C1,0.018,0.989,0,0.975,0"
        ></path>
      </clipPath>
    </svg>
    <svg class="svg2">
      <clipPath id="imageClipper2" clipPathUnits="objectBoundingBox">
        <path
          d="M0.962,0 H0.765 C0.744,0,0.727,0.028,0.727,0.063 V0.088 C0.727,0.122,0.71,0.15,0.688,0.15 H0.038 C0.017,0.15,0,0.178,0,0.213 V0.938 C0,0.972,0.017,1,0.038,1 H0.962 C0.983,1,1,0.972,1,0.938 V0.063 C1,0.028,0.983,0,0.962,0"
        ></path>
      </clipPath>
    </svg>
    <svg class="svg3">
      <clipPath id="imageClipper3" clipPathUnits="objectBoundingBox">
        <path
          d="M0.983,0 H0.164 C0.155,0,0.147,0.01,0.147,0.022 C0.147,0.035,0.14,0.045,0.13,0.045 H0.017 C0.007,0.045,0,0.055,0,0.067 V0.978 C0,0.99,0.007,1,0.017,1 H0.983 C0.993,1,1,0.99,1,0.978 V0.022 C1,0.01,0.993,0,0.983,0"
        ></path>
      </clipPath>
    </svg>
    <svg class="svg4">
      <clipPath id="imageClipper4" clipPathUnits="objectBoundingBox">
        <path
          d="M0.961,0 H0.323 C0.301,0,0.284,0.023,0.284,0.052 V0.052 C0.284,0.08,0.267,0.104,0.245,0.104 H0.039 C0.017,0.104,0,0.127,0,0.155 V0.948 C0,0.977,0.017,1,0.039,1 H0.961 C0.983,1,1,0.977,1,0.948 V0.052 C1,0.023,0.983,0,0.961,0"
        ></path>
      </clipPath>
    </svg>
    <svg
      v-if="isMobile"
      class="svg6"
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="412"
      viewBox="0 0 101 412"
      fill="none"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M4.45507 228.958C-4.25065 101.197 114.114 -14.9146 174.384 -57L274 540C187.779 489.553 13.1608 356.719 4.45507 228.958Z"
          stroke="white"
          stroke-opacity="0.2"
          stroke-width="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter0_f)">
          <circle
            cx="28.5"
            cy="113.5"
            r="4.5"
            fill="white"
            fill-opacity="0.25"
          />
        </g>
        <g filter="url(#filter1_f)">
          <ellipse
            cx="2.04524"
            cy="212.435"
            rx="1.9588"
            ry="7.41119"
            transform="rotate(-0.669319 2.04524 212.435)"
            fill="#65A5AA"
          />
        </g>
        <g filter="url(#filter2_f)">
          <circle cx="31" cy="106" r="3" fill="white" fill-opacity="0.25" />
          <circle
            cx="31"
            cy="106"
            r="3.25"
            stroke="#4A8D98"
            stroke-width="0.5"
          />
        </g>
        <g filter="url(#filter3_f)">
          <circle cx="35" cy="101" r="3" fill="white" fill-opacity="0.25" />
          <circle
            cx="35"
            cy="101"
            r="3.25"
            stroke="#4A8D98"
            stroke-width="0.5"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f"
          x="22"
          y="107"
          width="13"
          height="13"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="filter1_f"
          x="-4"
          y="201.001"
          width="12.0908"
          height="22.8672"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="filter2_f"
          x="25.5"
          y="100.5"
          width="11"
          height="11"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="filter3_f"
          x="29.5"
          y="95.5"
          width="11"
          height="11"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
        </filter>
        <clipPath id="clip0">
          <rect width="101" height="412" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <!-- content -->
    <div class="page">
      <template v-for="(item, index) in list" :key="index" class="page">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          class="page-content"
        >
          <h2>{{ item.sub_category.name }}</h2>
          <ImageContainer
            class="img"
            :src="item.image.medium"
            :alt="item.title"
            :thumb="item.image.thumbnail"
          />
          <div class="content">
            <h6 v-if="index === 0 && isIpad">{{ item.sub_category.name }}</h6>
            <h1>{{ item.title }}</h1>
            <h4>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h4>
          </div>
        </router-link>
        <!-- heart -->
        <svg
          class="heart"
          v-if="index == 0 && !isIpad"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 442 389"
          fill="none"
        >
          <path
            d="M212.473 385.565C87.8 276.392 0 218.563 0 126.58C0 57.0215 49.5523 0 117.406 0C164.493 0 199.433 28.9393 221 69.9918C242.566 28.9419 277.505 0 324.594 0C392.455 0 442 57.0328 442 126.58C442 218.552 354.315 276.292 229.527 385.564C224.644 389.84 217.355 389.84 212.473 385.565Z"
            fill="#228293"
          />
        </svg>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";

import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();
    const isMobile = ref();

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth < 414;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 414;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    return {
      isIpad,
      isMobile,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.pageWrapper {
  width: 100%;
  padding-top: 2.083vw;
  padding-bottom: 5.729vw;
  padding-left: 2.604vw;
  padding-right: 2.604vw;
  background: #136a8a;
  position: relative;
  z-index: 10;
  // image clipper
  .svg {
    position: absolute;
    width: 0;
    height: 0;
  }
  .svg2 {
    position: absolute;
    width: 0;
    height: 0;
  }
  .svg3 {
    position: absolute;
    width: 0;
    height: 0;
  }
  .svg4 {
    position: absolute;
    width: 0;
    height: 0;
  }
  // page style
  .page {
    width: 100%;
    display: grid;
    grid-template-areas:
      "content1 content2 content3"
      "content4 content5 content6";
    gap: 3vw;
    .page-content {
      width: 21.146vw;
      font-family: "Open Sans", sans-serif;
      font-style: normal;
      h2 {
        font-size: 0.833vw;
        line-height: 1.146vw;
        font-weight: 400;
        color: var(--light-b-color);
        grid-area: pageCategory;
        width: max-content;
        height: max-content;
      }
      .img {
        width: 21.146vw;
        height: 13.021vw;
        grid-area: pageImage;
        clip-path: url(#imageClipper);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      h1 {
        font-size: 0.938vw;
        line-height: 1.198vw;
        font-weight: 600;
        font-family: "Source Serif Pro", serif;
        font-style: normal;
        color: var(--light-m-color);
        grid-area: pageTitle;
        height: max-content;
      }
      h4 {
        font-size: 0.729vw;
        line-height: 0.99vw;
        font-weight: 300;
        color: var(--light-p-color);
        grid-area: publishedDate;
      }
      .content {
        h6 {
          color: var(--light);
        }
      }
      // areaName
      &:nth-child(1) {
        grid-area: content1;
        text-align: center;
      }
      &:nth-child(3) {
        grid-area: content3;
        text-align: center;
      }
      &:nth-child(4) {
        grid-area: content4;
      }
      &:nth-child(5) {
        grid-area: content5;
      }
      &:nth-child(6) {
        grid-area: content6;
      }
      // style

      &:nth-child(1),
      &:nth-child(3) {
        position: relative;
        h2 {
          position: absolute;
          top: 0;
          left: 0;
          width: 9vw;
          text-align: center;
        }
      }
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6) {
        width: 100%;
        display: grid;
        grid-template-areas:
          "pageCategory pageCategory"
          "pageImage pageTitle"
          "pageImage pageTitle";
        align-items: center;
        position: relative;
        gap: 0.521vw;
        .content {
          display: flex;
          flex-direction: column;
          grid-area: pageTitle;
          h1 {
            margin-bottom: 0.313vw;
          }
        }
        .img {
          width: 13.542vw;
          height: 8.333vw;
          clip-path: url(#imageClipper);
        }
        h2 {
          width: 5.8vw;
          text-align: center;
          position: absolute;
          top: 0.2vw;
          left: 0;
        }
      }
      // heart
      .heart {
        width: 23.021vw;
        height: 20.26vw;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .pageWrapper {
    background: linear-gradient(180deg, #136a8a 0%, #267871 100%);
    position: relative;
    overflow: hidden;
    padding-top: 4.557vw;
    padding-bottom: 10.417vw;
    // ellipse
    .svg5 {
      position: absolute;
      right: 0;
      top: 31.25vw;
      width: 25.13vw;
      height: 109.375vw;
      z-index: 2;
      fill: none;
    }
    // page style
    .page {
      display: grid;
      grid-template-areas:
        "content1"
        "content2"
        "content3"
        "content4"
        "content5"
        "content6";
      .page-content {
        h2 {
          font-size: 1.393vw;
          line-height: 2.344vw;
        }
        h1 {
          font-size: 2.083vw;
          line-height: 2.865vw;
        }
        h4 {
          font-size: 1.693vw;
          line-height: 2.344vw;
        }
        // blogs style
        &:nth-child(1) {
          width: 77.865vw;
          height: 58.333vw;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          margin-bottom: 4.557vw;
          .img {
            width: 77.865vw;
            height: 58.333vw;
            display: flex;
            align-items: center;
            clip-path: url(#imageClipper3);
          }
          .content {
            width: 51.042vw;
            margin-left: auto;
            margin-right: auto;
            h6 {
              margin-bottom: 0.391vw;
            }
          }
          h2 {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: left;
          width: 84vw;
          height: 25.13vw;
          margin-top: 7vw;
          position: relative;
          .img {
            width: 33.464vw;
            height: 25.13vw;
            clip-path: url(#imageClipper4);
          }
          .content {
            width: 49.349vw;
            height: 8.854vw;
            margin: auto;
          }
          h2 {
            width: 10vw;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .pageWrapper {
    background: linear-gradient(180deg, #136a8a 0%, #267871 100%);
    position: relative;
    overflow: hidden;
    // eliipse
    .svg6 {
      position: absolute;
      right: 0;
      top: 68.841vw;
      width: 24.396vw;
      height: 99.517vw;
      z-index: 2;
      fill: none;
    }
    // page style
    .page {
      display: grid;
      grid-template-areas:
        "content1"
        "content2"
        "content3"
        "content4"
        "content5"
        "content6";
      .page-content {
        h2 {
          font-size: 2.415vw;
          line-height: 3.382vw;
        }
        h1 {
          font-size: 2.899vw;
          line-height: 3.623vw;
        }
        h4 {
          font-size: 2.415vw;
          line-height: 3.382vw;
        }
        // blogs style
        &:nth-child(1) {
          width: 71.256vw;
          height: 53.382vw;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          margin-bottom: 12.831vw;
          .img {
            width: 71.256vw;
            height: 53.382vw;
            display: flex;
            align-items: center;
            clip-path: url(#imageClipper4);
          }
          .content {
            width: 51.042vw;
            height: 8.854vw;
            margin-left: auto;
            margin-right: auto;
            margin-top: 0.966vw;
            h6 {
              display: none;
            }
          }
          h2 {
            position: absolute;
            top: 1vw;
            left: 1vw;
          }
        }
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: left;
          width: 85.024vw;
          height: 25.13vw;
          margin-top: 4.831vw;
          position: relative;
          .img {
            width: 33.464vw;
            height: 25.13vw;
            clip-path: none;
          }
          .content {
            width: 49.034vw;
            height: 8.854vw;
            margin-left: 1.208vw;
          }
          h2 {
            position: absolute;
            left: 35.406vw;
            top: 4vw;
          }
        }
      }
    }
  }
}
</style>